import { queryClient } from '@/client/query';
import actionPlan from '@/repositories/action-plan.repository';
import { useMutation, useQuery } from '@tanstack/react-query';

export function useActionPlan() {
  return useQuery({
    queryKey: ['action-plan', 'get'],
    queryFn: actionPlan.get,
  });
}

export function useSaveActionPlanMutation() {
  return useMutation({
    mutationFn: actionPlan.put,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['action-plan', 'get'] });
    },
  });
}
